import { render, staticRenderFns } from "./special_control_pile.vue?vue&type=template&id=4fbfc750&scoped=true&"
import script from "./special_control_pile.vue?vue&type=script&lang=js&"
export * from "./special_control_pile.vue?vue&type=script&lang=js&"
import style0 from "./special_control_pile.vue?vue&type=style&index=0&id=4fbfc750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfc750",
  null
  
)

export default component.exports